import { ChangeDetectionStrategy, Component, type OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-paid-elements-modal',
    templateUrl: './paid-elements-modal.component.html',
    styleUrls: ['./paid-elements-modal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateModule],
})
export class PaidElementsModalComponent implements OnInit {
    private readonly bsModalRef = inject(BsModalRef);

    public onClose: Subject<boolean>;
    public widgetNames: string[];

    public ngOnInit(): void {
        this.onClose = new Subject();
    }

    public onConfirm(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }

    public onCancel(): void {
        this.onClose.next(false);
        this.bsModalRef.hide();
    }
}
